import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { forkJoin, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { NotificationService} from '../../_services/notification.service';
import { StorageService } from '../../_services/storage.service';
import { UserService} from '../../_services/user.service';
import { AuthService} from '../../_services/auth.service';

import { SettingsService } from '../../_services/settings.service';
import { LoginSsoRequestDto, TokenDto } from '../../_services/auth.dto';
import { UserDto } from '../../_services/user.dto';
import { consumeSsoFlow } from '../../_helpers/sso-flow';

@Component({
    selector: 'app-is-connected',
    templateUrl: './is-connected.component.html',
    styleUrl: './is-connected.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class IsConnectedComponent implements OnInit{

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient, 
    private router: Router,
    private notificationService:NotificationService,
      private auth:AuthService,
      private storageService:StorageService,
      private userService:UserService,
    private settingsService: SettingsService

  ) {}

  errorStatus= null;

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      const code = params['code'];
      const error = params['error'];
      const errorDescription = params['error_description'];
    
//      error=temporarily_unavailable&error_description=authentication_expired
      if (error){

      } else {
        if (code) {
          const codeVerifier = consumeSsoFlow(params['state']);
          if (!codeVerifier) {
            this.notificationService.addNotification({
              type: 'alert',
              message: 'La connexion SSO n\'a pas pu être vérifiée, merci de vous reconnecter',
            });
            return;
          }
          this.ssologin(code, codeVerifier)
        }
      }

    });
  }


ssologin(code: string, codeVerifier: string) {
  const protocol = window.location.protocol;
  const host = window.location.host;

  const origin = protocol + '//' + host

  this.auth.login_sso(code, origin, codeVerifier).subscribe({
    next: (token: TokenDto) => {
      this.storageService.clean()
      this.storageService.saveToken(token);

      this.notificationService.addNotification({
        type: 'success',
        message: 'Connexion SynthIA réussie',
      });

      forkJoin({
        user: this.userInfo(),
        settings: this.settingsService.loadSettings().pipe(
          catchError((err) => {
            console.error('Erreur loadSettings', err);
            return of(null); // on ne bloque pas la suite
          })
        )
      }).subscribe({
        next: ({ user, settings }) => {
          if (user?.refresh_password === 1) {
            this.router.navigateByUrl('/user', { replaceUrl: true });
          } else {
            this.router.navigateByUrl('/chat', { replaceUrl: true });
          }
        },
        error: (err) => {
          console.error('Erreur après login', err);
          this.router.navigateByUrl('/chat', { replaceUrl: true });
        }
      });
    },
    error: (err: { status: number; error: { message: string } }) => {
      if (err.status == 404) {
        this.notificationService.addNotification({
          type: 'alert',
          message: 'Nom d\'utilisateur ou mot de passe incorrect',
        });
      } else if (err.status == 423) {
        this.notificationService.addNotification({
          type: 'alert',
          message: 'Votre compte a été bloqué, merci de contacter un administrateur',
        });
      } else {
        this.notificationService.addNotification({
          type: 'alert',
          message: 'Une erreur non gérée vient de se produire',
        });
      }
    }
  });
}

userInfo() {
  return this.userService.me().pipe(
    tap((ev: UserDto) => {
      this.storageService.saveInfoUser(ev);
    })
  );
}

}




